import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const GoodsDetail = () => import('@/views/goodsdetails/GoodsDetail')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Recharge
const Recharge = () => import('@/views/Order/Recharge')
// Shopping
const Shopping = () => import('@/views/Order/Shopping')

// My
const My = () => import('@/views/My/My')

// MyInfo
const MyInfo = () => import('@/views/My/MyInfo')

// BindingWX
const BindingWX = () => import('@/views/My/BindingWX')

// BindingDH
const BindingMobile = () => import('@/views/My/BindingDH')

// ShoppingOrderList
const ShoppingOrder = () => import('@/views/Order/ShoppingOrder')

// MyMessage
const MyMessage = () => import('@/views/My/MyMessage')

// MyUser
const MyUser = () => import('@/views/My/MyUser')

// ShoppingOrderDetails
const ShoppingOrderDetails = () => import('@/views/Order/ShoppingOrderDetails')

// Clubber
const Clubber = () => import('@/views/Clubber/Clubber')

// ShareYD
const ShareHJ = () => import('@/views/pages/ShareHJ')

// ShareHJWithCode
const ShareHJWithCode = () => import('@/views/pages/ShareHJWithCode')

//
const SubUserShoppingOrder = () => import('@/views/Order/SubUserShoppingOrder')

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),

  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      hidden: true
    },
    { path: '/p404', name: 'Page404', component: Page404, hidden: true },
    {
      path: '/p505',
      name: 'Page500',
      component: Page500,
      hidden: true
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      hidden: true
    },
    {
      path: '/sharehj',
      name: 'ShareHJ',
      component: ShareHJ,
      hidden: true
    },
    {
      path: '/sharehjwithcode',
      name: 'ShareHJWithCode',
      component: ShareHJWithCode,
      hidden: true
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/goodsdetail',
          name: 'GoodsDetail',
          component: GoodsDetail
        },
        {
          path: '/recharge',
          name: 'Recharge',
          component: Recharge
        },
        {
          path: '/shopping',
          name: 'Shopping',
          component: Shopping
        },

        {
          path: '/my',
          name: 'My',
          component: My
        },
        {
          path: '/shoppingorder',
          name: 'ShoppingOrder',
          component: ShoppingOrder
        },
        {
          path: '/myinfo',
          name: 'MyInfo',
          component: MyInfo
        },
        {
          path: '/bindingwx',
          name: 'BindingWX',
          component: BindingWX
        },
        {
          path: '/bindingmobile',
          name: 'BindingMobile',
          component: BindingMobile
        },
        {
          path: '/mymessage',
          name: 'MyMessage',
          component: MyMessage
        },
        {
          path: '/myuser',
          name: 'MyUser',
          component: MyUser
        },
        {
          path: '/subusershoppingorder',
          name: 'SubUserShoppingOrder',
          component: SubUserShoppingOrder
        },
        {
          path: '/shoppingorderdetails',
          name: 'ShoppingOrderDetails',
          component: ShoppingOrderDetails
        },
        {
          path: '/clubber',
          name: 'Clubber',
          component: Clubber
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js